export default "__VITE_ASSET__DVMENEJ5__"